export default "__VITE_ASSET__CLPomqQZ__"